import React, { useEffect, useState } from "react";
import {Link} from "react-router-dom";
import Close from "../../images/Close.png";


const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result.toISOString().split("T")[0];
};


const OrderRentModal = ({ closeModal, openSuccessful, KIT, rentDays, modalRef }) => {
    const [incorrectNum, setIncorrectNum] = useState(false);
    const [todayDate, setTodayDate] = useState("");
    const [formData, setFormData] = useState(() => {
        const today = new Date().toISOString().split("T")[0];
        const initialTermEndDate = rentDays ? addDays(today, rentDays) : "";

        return {
            name: "",
            phoneNumber: "+380 ",
            kit: KIT || "DEFAULT",
            termStartDate: today,
            termEndDate: initialTermEndDate,
            preferredCommunicationType: "PHONE_CALL",
            agreeToPrivacyPolicy: false,
            receiveAds: false,
        };
    });

    useEffect(() => {
        if (rentDays > 0 && formData.termStartDate) {
            const calculatedEndDate = addDays(formData.termStartDate, rentDays);
            setFormData((prevData) => ({
                ...prevData,
                termEndDate: calculatedEndDate,
            }));
        }
    }, [rentDays, formData.termStartDate]);

    useEffect(() => {
        if (KIT) {
            setFormData((prev) => ({
                ...prev,
                kit: KIT,
            }));
        }
    }, [KIT]);

    useEffect(() => {
        setTodayDate(new Date().toISOString().split("T")[0]);
    }, []);

    const [fetchErrorStatus, setFetchErrorStatus] = useState(false);
    const today = new Date().toISOString().split("T")[0];

    const formatPhoneNumber = (value) => {
        let digits = value.replace(/\D/g, "");
        if (!digits.startsWith("380")) digits = "380";
        if (digits.length > 12) digits = digits.slice(0, 12);

        let formatted = "+380 ";
        if (digits.length > 3) formatted += `(${digits.slice(3, 5)}`;
        if (digits.length > 5) formatted += `) ${digits.slice(5, 8)}`;
        if (digits.length > 8) formatted += `-${digits.slice(8, 10)}`;
        if (digits.length > 10) formatted += `-${digits.slice(10, 12)}`;

        return formatted;
    };

    const handleChange = (e) => {
        let { name, value, type, checked } = e.target;

        setFormData((prev) => {
            let updatedData = {
                ...prev,
                [name]: type === "checkbox" ? checked : name === "phoneNumber" ? formatPhoneNumber(value) : value,
            };

            if (name === "phoneNumber") {
                let digits = value.replace(/\D/g, "");
                if (digits.length === 12) {
                    setIncorrectNum(false);
                }
            }

            if (name === "name") {
                updatedData.name = value.replace(/[^a-zA-Zа-яА-ЯіІєЄїЇ ]/g, "");
            }

            if (name === "termStartDate" && (!prev.termEndDate || prev.termEndDate <= value)) {
                updatedData.termEndDate = addDays(value, 1);
            }

            return updatedData;
        });
    };

    const handleKeyDown = (e) => {
        if (e.target.name === "phoneNumber" && e.target.selectionStart < 5 && e.key !== "ArrowRight" && e.key !== "Tab") {
            e.preventDefault();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.phoneNumber.length < 19) {
            setIncorrectNum(true);
            return;
        }

        let requestData = {
            name: formData.name,
            phoneNumber: formData.phoneNumber,
            kit: formData.kit,
            termStartDate: formData.termStartDate,
            termEndDate: formData.termEndDate,
            preferredCommunicationType: formData.preferredCommunicationType,
        };

        try {
            const response = await fetch("https://crm.pixelgame.com.ua/api/leads", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                throw new Error("Помилка при надсиланні даних");
            }

            setFetchErrorStatus(false);
            setFormData({
                name: "",
                phoneNumber: "+380 ",
                kit: "DEFAULT",
                termStartDate: "",
                termEndDate: "",
                preferredCommunicationType: "PHONE_CALL",
                agreeToPrivacyPolicy: false,
                receiveAds: false,
            });
            setIncorrectNum(false);
            closeModal();

            // Push lead_submit event to dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'lead_submit',
            });
            console.log("Event 'lead_submit' has been pushed")

            setTimeout(() => {
                openSuccessful();
            }, 300);
        } catch (error) {
            console.error("Помилка:", error);
            setFetchErrorStatus(true);
        }
    };

    const handleCloseBtn = () => {
      modalRef.current.close();
        setFormData({
            name: "",
            phoneNumber: "+380 ",
            kit: "DEFAULT",
            termStartDate: today,
            termEndDate: "",
            preferredCommunicationType: "PHONE_CALL",
            agreeToPrivacyPolicy: false,
            receiveAds: false,
        });
        setFetchErrorStatus(false);
        setIncorrectNum(false);
    }

    return (
        <>
            <div className='close-btn'>
                <button onClick={() => handleCloseBtn()}><img src={Close} alt=""/></button>
            </div>
            <form onSubmit={handleSubmit} className="order-modal">
                <div className="order-modal-container">
                    <h1 className="order-header">Ваше Замовлення:</h1>
                    {fetchErrorStatus && <p className="modal-error">Щось пішло не так. Спробуйте ще раз пізніше!</p>}

                    <input className="modal-input" name="name" value={formData.name} onChange={handleChange}
                           placeholder="Ваше ім'я" type="text" required/>
                    {incorrectNum && <span className='modal-error'>Номер повинен містити 12 цифр</span>}
                    <input maxLength={19} className="modal-input" name="phoneNumber"
                           placeholder="+380 (99) 999-99-99" type="text" value={formData.phoneNumber}
                           onChange={handleChange}
                           onKeyDown={handleKeyDown}
                           required/>
                    <label htmlFor="dropdown">
                        <h2 className="order-p">Комплект</h2>
                    </label>
                    <select className="modal-input" id="dropdown" name="kit" value={formData.kit}
                            onChange={handleChange}>
                        <option className="option" value="DEFAULT">Потрібна допомога менеджера</option>
                        <option className="option" value="META_QUEST_3_KIT">Meta Quest 3</option>
                        <option className="option" value="PS4_PRO_KIT">PlayStation 4 Pro</option>
                        <option className="option" value="PS5_BLU_RAY_KIT"> PlayStation 5 Blu-Ray</option>
                        <option className="option" value="PS5_SLIM_BLU_RAY_KIT"> PlayStation 5 Slim</option>
                        <option className="option" value="XBOX_SERIES_S_KIT">Xbox Series S</option>
                        <option className="option" value="XBOX_SERIES_X_KIT">Xbox Series X</option>
                    </select>

                    <h2 className="order-p order-p-time">Термін оренди</h2>
                    <div className="date-inputs">
                        <label className="date-label">
                            Дата початку:
                            <input
                                name="termStartDate"
                                className="date-input"
                                type="date"
                                value={formData.termStartDate}
                                onChange={handleChange}
                                min={todayDate}
                                required
                            />
                        </label>
                        <label className="date-label">
                            Дата кiнця:
                            <input
                                name="termEndDate"
                                className="date-input"
                                type="date"
                                value={formData.termEndDate}
                                onChange={handleChange}
                                min={
                                    formData.termStartDate
                                        ? addDays(formData.termStartDate, 1)
                                        : addDays(today, 1)
                                }
                                required
                            />
                        </label>
                    </div>

                    <h2 className="order-p">Зручний спосіб зв'язку</h2>
                    <select className="modal-input" id="method" name="preferredCommunicationType"
                            value={formData.preferredCommunicationType} onChange={handleChange}>
                        <option className="option" value="PHONE_CALL">Дзвінок</option>
                        <option className="option" value="TELEGRAM">Telegram</option>
                        <option className="option" value="VIBER">Viber</option>
                    </select>

                    <div className="order-labels">
                        <label className="order-label">
                            <input className="custom-checkbox" type="checkbox" name="agreeToPrivacyPolicy"
                                   checked={formData.agreeToPrivacyPolicy} onChange={handleChange} required/>
                            <span style={{color: "red", fontSize: "22px"}}>*</span> Я згоден на <Link to="/privacy"
                                                                                                      target="_blank"
                                                                                                      rel="noopener noreferrer">обробку
                            персональних данних</Link>
                        </label>

                        <label className="order-label">
                            <input className="custom-checkbox" type="checkbox" name="receiveAds"
                                   checked={formData.receiveAds} onChange={handleChange}/>
                            Я хочу отримувати інформаційні та рекламні сповіщення
                        </label>
                    </div>

                    <div style={{textAlign: "center"}}>
                        <button type="submit" className="red-btn order-btn">
                            Отримати консоль
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default OrderRentModal;
